module.exports = __webpack_public_path__ + "fonts/roboto-black-webfont.ttf";